import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {MAX_SHEETS} from '../constants';
import actions from '../actions';

const CLASS_NAME = 'slx-product-wizard-sheet-button';

export default createReactClass({

	propTypes: {
		visible: PropTypes.bool,
		inactive: PropTypes.bool,
		stick: PropTypes.string,
		itemCount: PropTypes.number,
		accessoryCount: PropTypes.number
	},

	showSheet() {
		if (!this.props.inactive && this.props.itemCount === 1) {
			actions.loadItemSheet();
		}
	},

	render() {
		if (!this.props.visible) return false;

		let className = CLASS_NAME;
		if (this.props.inactive || this.props.itemCount !== 1) {
			className += ' inactive';
		}
		if (this.props.stick === 'bottom') {
			className += ` ${CLASS_NAME}--stick ${CLASS_NAME}--stick-bottom`;
		}
		if (this.props.stick === 'top') {
			className += ` ${CLASS_NAME}--stick ${CLASS_NAME}--stick-top`;
		}
		let count = this.props.itemCount + this.props.accessoryCount;
		if (count > MAX_SHEETS) {
			count = `${MAX_SHEETS}+`;
			className += ' pending';
		}
		return (
			<div className={'slx-product-wizard-sheet-button-wrap'} ref="button">
				<button className={`${className}`} onClick={this.showSheet}>
					<span className={`${CLASS_NAME}__count`}>{count}</span>
					<span className={`${CLASS_NAME}__icon`}>
						<svg viewBox="0 0 32 41">
							<polyline points="20.9,0.5 20.9,10 30.5,10 "/>
							<polyline points="0.5,0.5 0.5,40.3 30.5,40.3 30.5,10.1 20.9,0.5 0.5,0.5 "/>
						</svg>
					</span>
					<span className={`${CLASS_NAME}__label`}>View Specsheet and Downloads Now</span>
				</button>
			</div>
		);
	}
});
